import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentSports: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.25.035A7.25 7.25 0 0 1 .035 7.25A8 8 0 0 1 7.25.035\"/><path fill=\"currentColor\" d=\"M8.75.035a8 8 0 0 1 7.215 7.215a8.75 8.75 0 0 0-8.715 8.715A8 8 0 0 1 .035 8.75A8.75 8.75 0 0 0 8.75.035\"/><path fill=\"currentColor\" d=\"M15.965 8.75a8 8 0 0 1-7.215 7.215a7.25 7.25 0 0 1 7.215-7.215\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default entertainmentSports
